/* LSD course pages: design polish v1.
   Presentation only. Every value shown is read from the page's own content
   (Course Details lists, the hero heading and the existing booking anchor);
   nothing is typed in here. Runs after lsd-inner-v1.js (both deferred). */
(function(){
  var KEYS=['price','duration','minimum age','prerequisite','prerequisites','location'];
  var ORDER={'price':0,'duration':1,'minimum age':2,'prerequisite':3,'prerequisites':3,'location':4};

  function labelled(li){
    var strong=li.querySelector(':scope > strong');
    if(!strong) return null;
    var label=strong.textContent.replace(/:\s*$/,'').trim();
    var full=li.textContent.replace(/\s+/g,' ').trim();
    var head=strong.textContent.replace(/\s+/g,' ').trim();
    if(full.indexOf(head)!==0) return null;
    return {key:label.toLowerCase(),label:label,value:full.slice(head.length).trim()};
  }

  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;}

  function bookingTarget(){return document.getElementById('course-booking');}

  function buildKeyFacts(content){
    if(content.querySelector('.lsd-course-keyfacts')) return;
    var opening=content.querySelector(':scope > .lsd-course-story__opening');
    if(!opening) return;
    var facts=[];

    // A. Fact-card pages: pick labelled rows from the (non "important") Course Details card.
    content.querySelectorAll(':scope > .lsd-course-story__facts > .lsd-course-fact-card:not(.lsd-course-fact-card--important)').forEach(function(card){
      card.querySelectorAll('li').forEach(function(li){
        var f=labelled(li);
        if(!f || KEYS.indexOf(f.key)===-1 || !f.value) return;
        if(f.key==='price') li.classList.add('lsd-course-fact--price');
        if(facts.some(function(x){return x.key===f.key;})) return;
        facts.push(f);
      });
    });
    facts.sort(function(a,b){return ORDER[a.key]-ORDER[b.key];});

    // B. Route pages (e.g. Start Diving): one price per route, labelled by that route's own heading.
    if(!facts.length){
      content.querySelectorAll('.lsd-course-route-list:not(.lsd-course-route-list--important) li').forEach(function(li){
        var f=labelled(li);
        if(!f || f.key!=='price' || !f.value) return;
        li.classList.add('lsd-course-fact--price');
        var stage=li.closest('.lsd-course-route-stage');
        var group=li.closest('.lsd-course-route-group');
        var heading=stage ? stage.querySelector(':scope > h4') : null;
        var title=heading ? heading.textContent.trim() : (group && group.querySelector('.lsd-course-route-group__header .eyebrow') ? group.querySelector('.lsd-course-route-group__header .eyebrow').textContent.trim() : '');
        if(!title) return;
        var parts=title.split(/\s+[—–-]\s+/);
        facts.push({key:'price',label:parts[0],note:parts.slice(1).join(' — '),value:f.value});
        // Price tag on the route card itself, so it is visible while "Course Details" is collapsed.
        var host=heading || (group && group.querySelector('.lsd-course-route-group__header'));
        if(host && !(host.parentNode.querySelector(':scope > .lsd-course-price-tag'))){
          var tag=el('p','lsd-course-price-tag');
          tag.appendChild(el('span',null,f.label));
          tag.appendChild(document.createTextNode(f.value));
          if(heading) heading.insertAdjacentElement('afterend',tag); else host.appendChild(tag);
        }
      });
    }
    if(!facts.length) return;
    // v1.24: the dark "at a glance" stats strip carries these facts, so no second (white) strip.
    if(document.querySelector('.lsd-wow-stats')) return;

    var aside=el('aside','lsd-course-keyfacts');
    aside.setAttribute('aria-label','Course key facts');
    var dl=el('dl','lsd-course-keyfacts__list');
    facts.forEach(function(f){
      var item=el('div','lsd-course-keyfacts__item'+(f.key==='price'?' lsd-course-keyfacts__item--price':'')+((f.key==='price'?0:f.value.length)>30?' lsd-course-keyfacts__item--wide':'')+(f.key==='price'&&!/^£/.test(f.value)?' lsd-course-keyfacts__item--plain':''));
      var dt=el('dt',null,f.label);
      if(f.note){dt.appendChild(el('span','lsd-course-keyfacts__note',f.note));}
      item.appendChild(dt);
      var dd=el('dd');
      var m=f.key==='price' ? f.value.match(/^(£\d[\d,]*(?:\.\d{2})?)(?:\.\s+|\s+)(.+)$/) : null;
      if(m){ // e.g. "£389. EFR / CPR ..." -> big "£389" + the rest of the same sentence underneath
        dd.appendChild(document.createTextNode(m[1]));
        dd.appendChild(el('span','lsd-course-keyfacts__note',m[2]));
      } else dd.textContent=f.value;
      item.appendChild(dd);
      dl.appendChild(item);
    });
    aside.appendChild(dl);
    // Re-use the page's own booking CTA label if it has one, else the hero card's label.
    if(bookingTarget()){
      var existing=content.querySelector('a.button[href="#course-booking"]');
      var a=el('a','button',existing ? existing.textContent.trim() : 'View live availability');
      a.href='#course-booking';
      aside.appendChild(a);
    }
    opening.insertAdjacentElement('afterend',aside);
  }

  function bookingFallback(){
    var box=bookingTarget();
    if(!box) return;
    var url=box.getAttribute('data-lsd-booking-url');
    if(!url) return;
    setTimeout(function(){
      var widget=box.querySelector('.checkfront-widget');
      if(!widget || widget.querySelector('iframe') || box.querySelector('.hero-booking__fallback')) return;
      var p=el('p','hero-booking__fallback');
      var a=el('a','button','Continue to secure booking');
      a.href=url;
      p.appendChild(a);
      widget.insertAdjacentElement('afterend',p);
      // If the live widget turns up late, hand the space back to it.
      if('MutationObserver' in window){
        var mo=new MutationObserver(function(){ if(widget.querySelector('iframe')){ p.remove(); mo.disconnect(); } });
        mo.observe(widget,{childList:true,subtree:true});
      }
    },8000);
  }

  function bookbar(){
    var target=bookingTarget();
    if(!target || !('IntersectionObserver' in window) || document.querySelector('.lsd-course-bookbar')) return;
    var title=document.querySelector('.hero .display');
    var bar=el('div','lsd-course-bookbar');
    bar.setAttribute('role','region');
    bar.setAttribute('aria-label','Book this course');
    if(title) bar.appendChild(el('p','lsd-course-bookbar__title',title.textContent.trim()));
    var existing=document.querySelector('[data-lsd-page-content] a.button[href="#course-booking"]');
    var a=el('a','button',existing ? existing.textContent.trim() : 'View live availability');
    a.href='#course-booking';
    bar.appendChild(a);
    document.body.appendChild(bar);
    document.body.classList.add('lsd-has-bookbar');
    var footer=document.querySelector('.lsd-footer, footer');
    var state={booking:true,footer:false};
    function update(){
      var show=!state.booking && !state.footer;
      bar.classList.toggle('is-visible',show);
      a.tabIndex=show?0:-1;
      bar.setAttribute('aria-hidden',show?'false':'true');
    }
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.target===target){ state.booking=e.isIntersecting || e.boundingClientRect.top>0; }
        else { state.footer=e.isIntersecting; }
      });
      update();
    },{threshold:0}).observe(target);
    if(footer) new IntersectionObserver(function(entries){entries.forEach(function(e){state.footer=e.isIntersecting;});update();},{threshold:0}).observe(footer);
    update();
  }

  function init(){
    document.querySelectorAll('[data-lsd-page-content] > .lsd-course-story').forEach(buildKeyFacts);
    if(document.querySelector('[data-lsd-page-content] > .lsd-course-story')) bookbar();
    bookingFallback();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
}());

/* v1.22/v1.22c/v1.22d Start Diving route cards: move each card's price tag onto its photo (the photo is attached by lsd-course-wow-v1.js). */
(function(){
  function place(){
    var left=0;
    document.querySelectorAll('.lsd-course-price-overlay').forEach(function(w){
      var card=w.parentElement;
      var fig=card && card.querySelector(':scope > .lsd-wow-media');
      if(!fig){ left++; return; }
      fig.classList.add('lsd-wow-media--has-price');
      fig.appendChild(w);
    });
    inset();
    return left;
  }
  // Keep the tag inside the visible part of the photo when the photo bleeds past a clipped card edge.
  function inset(){
    document.querySelectorAll('.lsd-wow-media--has-price > .lsd-course-price-overlay').forEach(function(w){
      var fig=w.parentElement, host=fig.parentElement, clip=host;
      while(clip && clip!==document.body && getComputedStyle(clip).overflowX==='visible') clip=clip.parentElement;
      var f=fig.getBoundingClientRect(), c=(clip||host).getBoundingClientRect();
      w.style.setProperty('--lsd-price-dx',Math.max(0,Math.round(c.left-f.left))+'px');
      w.style.setProperty('--lsd-price-dy',Math.max(0,Math.round(c.top-f.top))+'px');
      w.style.setProperty('--lsd-price-dr',Math.max(0,Math.round(f.right-c.right))+'px');
      w.style.setProperty('--lsd-price-db',Math.max(0,Math.round(f.bottom-c.bottom))+'px');
    });
  }
  // v1.22d: when the Standard and Expanded groups sit side by side, give their dark headers the same height so the photos line up.
  // v1.22d: the Expanded photo bleeds to the card edges exactly like Part A/B (cancel whatever padding its card has at this width).
  function bleed(){
    var g=document.querySelector('.lsd-course-story--start-diving .lsd-course-route-expanded-grid');
    var f=g && g.querySelector(':scope > .lsd-wow-media--card-top');
    if(!f) return;
    var cs=getComputedStyle(g);
    f.style.setProperty('margin-top','-'+cs.paddingTop,'important');
    f.style.setProperty('margin-left','-'+cs.paddingLeft,'important');
    f.style.setProperty('margin-right','-'+cs.paddingRight,'important');
  }
  function heads(){
    bleed();
    var hs=[document.querySelector('.lsd-course-story--start-diving .lsd-course-route-group--standard > .lsd-course-route-group__header'),document.querySelector('.lsd-course-story--start-diving .lsd-course-route-group--expanded > .lsd-course-route-group__header')].filter(Boolean);
    if(hs.length<2) return;
    hs.forEach(function(h){ h.style.minHeight=''; });
    var t=hs.map(function(h){ return Math.round(h.getBoundingClientRect().top); });
    if(Math.abs(t[0]-t[1])>40) return;
    var m=Math.max.apply(null,hs.map(function(h){ return h.getBoundingClientRect().height; }));
    hs.forEach(function(h){ h.style.minHeight=Math.ceil(m)+'px'; });
    // then line the photos themselves up (the two card types pull their photos up by different amounts)
    var fs=hs.map(function(h){ return h.parentElement.querySelector('.lsd-wow-media--card-top'); });
    if(!fs[0] || !fs[1]) return;
    var d=Math.round(fs[0].getBoundingClientRect().top-fs[1].getBoundingClientRect().top);
    if(d>0) hs[1].style.minHeight=Math.ceil(m+d)+'px'; else if(d<0) hs[0].style.minHeight=Math.ceil(m-d)+'px';
  }
  window.addEventListener('resize',function(){ heads(); inset(); },{passive:true});
  window.addEventListener('load',function(){ heads(); inset(); });
  function init(){
    heads();
    if(!document.querySelector('.lsd-course-price-overlay')) return;
    if(!place()) return;
    if(!('MutationObserver' in window)) return;
    var mo=new MutationObserver(function(){ if(!place()) mo.disconnect(); });
    mo.observe(document.querySelector('[data-lsd-page-content]')||document.body,{childList:true,subtree:true});
    setTimeout(function(){ mo.disconnect(); },15000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
}());
